// HEADER
// ===================================================

var header = {

    settings: {
        alert_banner_close: $('.alert-banner .js-close-button'),
        desktop_breakpoint: 1280,
        hamburger: $('header .hamburger'),
        header: $('header'),
        header_overlay: $('.site-header-overlay'),
        parent_items: $('header .menu-item-has-children'),
        scroll_pos: 0,
        search_bar: $('.header-search-bar'),
        search_bar_buttons: $('.search-button-mobile, .search-button-desktop, .js-header-search-bar-close'),
        skip_to_content: $('.skip-to-content'),
        sticky_header_timestamp: 0,
    },

    init: function() {
        // Bind events
        header.bindUIActions();
    },

    bindUIActions: function() {
        // On resize
        $(window).resize(global_helpers.debounce(header.resetMenus, 250));
        // On scroll
        $(window).scroll(global_helpers.debounce(header.resizeHeader, 250));
        // On key press
        $(document).on('keydown', header.keyActions);
        // Close Alert Banner
        this.settings.alert_banner_close.on('click', header.closeAlertBanner);
        // Open/Close Mobile Menu
        this.settings.hamburger.on('click', header.toggleMobileMenu);
        // Open/Close Mobile Sub-Menus
        this.settings.parent_items.on('click', header.toggleMobileSubMenu);
        // Open/Close Search Bar
        this.settings.search_bar_buttons.on('click keydown', header.toggleSearchBar);
        // Close all menus when clicking header overlay
        this.settings.header_overlay.on('click', header.closeAllMenus);
        // Hover states for desktop menus
        this.desktopMenus();
        // Skip to content link
        this.skipToContent();
    },

    // Close alert banner
    closeAlertBanner: function() {
        $(this).closest('.alert-banner').remove();
    },

    // Close all open menus
    closeAllMenus: function() {
        $('body').removeClass('no-scroll');
        $('.menu-open').removeClass('menu-open');
    },

    desktopMenus: function() {
        // Main menu
        var main_menu = $('#menu-header-main');
        // Parent level menu items that have sub-menus
        var parents = $('header .menu-item--parent');
        // Child level menu items that have sub-menus
        var children = $('header .sub-menu-wrapper--child > .sub-menu .menu-item');
        // Desktop grandchild menus
        var submenus = $('header .sub-menus--desktop > .sub-menu-wrapper');

        // Initialize
        resetParentMenus();

        function resetParentMenus() {
            // Revert all menu items
            parents.find('.active').removeClass('active');
            // Activate first menu item
            children.eq(1).addClass('active');
            // Activate first menu item sub-menu
            submenus.eq(0).addClass('active');
        }

        parents.on('keydown', function(e) {
            switch (e.keyCode) {
                // Enter
                case 13:
                // Spacebar
                case 32:
                    if (!$(this).hasClass('hovering')) {
                        e.preventDefault();
                        main_menu.addClass('hoverIntent');
                        parents.removeClass('hovering');
                        $(this).addClass('hovering');
                    }
                    break;
            }
        });

        parents.on('mouseenter', function() {
            $(this).addClass('hovering');
        });
        parents.on('mouseleave', function() {
            $(this).removeClass('hovering');
        });

        children.on('mouseenter keydown', function(e) {
            if ($(window).width() >= header.settings.desktop_breakpoint) {
                switch (e.keyCode) {
                    // Enter
                    case 13:
                    // Spacebar
                    case 32:
                        if (!$(this).hasClass('active')) {
                            e.preventDefault();
                        }
                        break;
                }
                // Revert all menu items
                children.removeClass('active');
                // Activate current menu item
                $(this).addClass('active');
                // Hide all sub-menus
                submenus.removeClass('active');
                // Get the index of the menu item (minus the title element)
                var index = $(this).index() - 1;
                // Activate that sub-menu
                submenus.eq(index).addClass('active');
            }
        });

        main_menu.hoverIntent({
            over: mainMenuActivate,
            out: mainMenuDeactivate,
            timeout: 0,
        });

        function mainMenuActivate() {
            main_menu.addClass('hoverIntent');
            header.settings.header_overlay.addClass('menu-open');
        }
        
        function mainMenuDeactivate() {
            resetParentMenus();
            main_menu.removeClass('hoverIntent');
            header.settings.header_overlay.removeClass('menu-open');
        }

    },

    // Perform actions based on keys pressed
    keyActions: function(e) {
        switch (e.keyCode) {
            // ESC
            case 27:
                header.closeAllMenus();
                break;
        }
    },

    // Reset menus based on screen size after resize
    resetMenus: function() {
        // Reset all menu classes when resizing from mobile > desktop
        if ($(window).width() >= header.settings.desktop_breakpoint) {
            header.closeAllMenus();
        }
    },
    
    // Resize desktop header on scroll up/down
    resizeHeader: function() {

        if ($(window).width() >= header.settings.desktop_breakpoint) {
            // Get the current scroll position
            var scroll = $(window).scrollTop();
            // Get the current timestamp
            var current_time = (new Date).getTime();
            // Cooldown period
            var cooldown = 500;

            // Restrict switching back and forth with a cooldown period
            if (current_time > header.settings.sticky_header_timestamp + cooldown) {

                header.settings.sticky_header_timestamp = current_time;
        
                if (scroll > header.settings.scroll_pos && scroll > 100) {
                    header.settings.header.addClass('sticky');
                    // Store the new value
                    header.settings.scroll_pos = scroll - 35;
                }
                else if (scroll < header.settings.scroll_pos) {
                    header.settings.header.removeClass('sticky');
                    // Store the new value
                    header.settings.scroll_pos = scroll + 35;
                }

            }
        }

    },

    // On clicking or activating the skip to content banner
    skipToContent: function() {
        header.settings.skip_to_content.on('click keypress', function() {
            // Find the first non-hero block
            var target = $('#main section:not([class*=hero])').first();
            // Switch focus
            if (target.length) {
                $(this).blur();
                var header = global_helpers.settings.header.outerHeight();
                var offset = target.offset().top - header;
                $('html, body').stop().animate({
                    scrollTop: offset
                }, 1000);
                target.focus();
            }
        });
    },

    // Open/Close mobile menus
    toggleMobileMenu: function() {
        if (!header.settings.header.hasClass('menu-open')) {
            $('body').addClass('no-scroll');
            header.settings.hamburger.addClass('menu-open');
            header.settings.header.addClass('menu-open');
            // Close search bar if it's open
            header.settings.search_bar.removeClass('menu-open');
        } else {
            header.closeAllMenus();
        }
    },

    // Open/Close mobile sub-menus
    toggleMobileSubMenu: function(e) {
        if ($(window).width() < header.settings.desktop_breakpoint) {
            e.stopPropagation();
            // Don't open menus on clicking link titles
            if (e.target.nodeName != 'A') {
                if ($(this).hasClass('sub-menu-title')) {
                    $(this).closest('.sub-menu-wrapper').removeClass('menu-open');
                } else {
                    $(this).children('.sub-menu-wrapper').addClass('menu-open');
                }
            }
        }
    },

    // Open/Close search bar
    toggleSearchBar: function(e) {
        if (global_helpers.accessibilityButtons(e)) {
            if (!header.settings.search_bar.hasClass('menu-open')) {
                // Close main menu if it's open
                header.closeAllMenus();
                header.settings.search_bar.addClass('menu-open');
                header.settings.header_overlay.addClass('menu-open');
                // Focus on search bar
                header.settings.search_bar.find('.input-search').focus();
            } else {
                header.closeAllMenus();
            }
        }
    },

};
header.init();